"use client";

import Link from 'next/link';
import Layout from '@/components/Layout';
import usePageTitle from '@/hooks/usePageTitle';
import Brandmark from '@/components/ui/Brandmark';
import { motion } from 'framer-motion';

export default function NotFound() {
  usePageTitle('Page Not Found — Laurel Web Co.');
  
  return (
    <Layout>
      <section 
        className="bg-bloom-green-deep pt-40 pb-24 min-h-[70vh] flex items-center"
        aria-label="Page not found"
      >
        <div className="container mx-auto px-6 text-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="flex justify-center mb-12"
          >
            <Brandmark size={240} className="text-bloom-gold opacity-40" />
          </motion.div>
          <h1 className="heading-hero text-primary-foreground mb-4">This page bloomed elsewhere.</h1>
          <p className="font-sans text-lg text-primary-foreground/95 mb-12 max-w-xl mx-auto">The page you're looking for doesn't exist or has moved.</p>
          <div className="flex flex-wrap justify-center gap-6">
            {[
              { label: 'Home', href: '/' }, 
              { label: 'Portfolio', href: '/portfolio' }, 
              { label: 'Services', href: '/services' }, 
              { label: 'Contact', href: '/contact' }
            ].map((link) => (
              <Link 
                key={link.href} 
                href={link.href} 
                className="font-sans text-sm font-semibold text-primary-foreground hover:underline focus-bloom rounded p-1"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
